import React from 'react'
import Footer from '../Layout/Footer'
import Header from '../Layout/Header'

function ServiceDetail() {
  return (
    <div>
        <Header />
             {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"   style={{backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"}}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Services Details</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                           Services Details
                        </li>
                    </ul>
                </div>
            </div>
            {/* <!-- <div class="gt-breadcrumb-image">
                <img src="assets/img/breadcrumb-image.jpg" alt="img">
            </div> --> */}
        </div>

        {/* <!-- Service Details Section Start --> */}
        <section class="service-details-section section-padding">
            <div class="container">
                <div class="service-details-wrapper">
                    <div class="row g-4">
                        <div class="col-lg-8">
                            <div class="gt-details-thumb">
                                <img src="assets/img/inner-page/service-details/details-01.jpg" alt="img"/>
                            </div>
                            <div class="gt-details-content">
                                <h2>Virtual Tours & Site Visits</h2>
                                <p class="mt-3">
                                   We make it easier than ever to discover your perfect commercial apartment through immersive virtual experiences and personalized in-person visits.
                                </p>
                                <span class="gt-box">
                                    Our team of UI/UX experts conducts a thorough evaluation o the submitted element, analyzing its usability, functionality
                                </span>
                                <div class="gt-list-content mb-0">
                                    <h3>Virtual Tours</h3>
                                    <ul>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                               360° Interactive Walkthroughs
                                            </span>
                                         Explore each room, floor plan, and amenity from your screen with high-resolution virtual tours.
                                        </li>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                              Live Video Tours (By Request)
                                            </span>
                                            Schedule a real-time video call with our agents to ask questions and get a live walkthrough of the property.
                                        </li>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                               Mobile-Friendly & VR-Compatible
                                            </span>
                                            View tours seamlessly on desktop, mobile, or virtual reality headsets.
                                        </li>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                               Instant Access, Anytime
                                            </span>
                                          No need to wait—view properties online at your convenience.
                                        </li>
                                    </ul>
                                </div>
                                <div class="row">
                                    <div class="col-xl-4 col-lg-6 col-md-6">
                                        <div class="details-img">
                                            <img src="assets/img/inner-page/service-details/details-02.jpg" alt="img"/>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-6 col-md-6">
                                        <div class="details-img">
                                            <img src="assets/img/inner-page/service-details/details-03.jpg" alt="img"/>
                                        </div>
                                        <div class="details-img style-2">
                                            <img src="assets/img/inner-page/service-details/details-04.jpg" alt="img"/>
                                        </div>
                                    </div>
                                     <div class="col-xl-4 col-lg-6 col-md-6">
                                        <div class="details-img">
                                            <img src="assets/img/inner-page/service-details/details-05.jpg" alt="img"/>
                                        </div>
                                    </div>
                                </div>
                               <div class="gt-list-content">
                                    <h3>On-Site Visits</h3>
                                    <ul>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                             Guided Property Tours
                                            </span>
                                        Book a personal visit with one of our experienced real estate professionals.
                                        </li>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                             Flexible Scheduling
                                            </span>
                                            Available 7 days a week to suit your business or travel needs.
                                        </li>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                               Health & Safety Assured
                                            </span>
                                            Sanitized spaces and safe visit protocols for your peace of mind.
                                        </li>
                                        <li>
                                            <span>
                                               <i class="flaticon-right-arrow"></i>
                                              Transportation Assistance (Optional)
                                            </span>
                                         Need a ride? We can arrange transport to and from the site.
                                        </li>
                                    </ul>
                                </div>
                                <h3>Ready to take the next step?</h3>
                                <p class="mt-3">Book a virtual or physical tour and let us help you find the perfect commercial apartment tailored to your goals.</p>
                                <div class="faq-content">
                                    <h3>Frequently Asked Question</h3>
                                    <div class="faq-accordion">
                                        <div class="accordion" id="accordion">
                                            <div class="accordion-item mb-4 wow fadeInUp" data-wow-delay=".5s">
                                                <h5 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq1" aria-expanded="false" aria-controls="faq1">
                                                        Can I participate in events without being a member?
                                                    </button>
                                                </h5>
                                                <div id="faq1" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                                    <div class="accordion-body">
                                                        Yes! We offer races and track days tailored for all skill levels. Whether you're a beginner or a seasoned pro, you'll find exciting challenges and opportunities to improve.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item mb-4 wow fadeInUp" data-wow-delay=".3s">
                                                <h5 class="accordion-header">
                                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq2" aria-expanded="true" aria-controls="faq2">
                                                        Are there events for beginners and experienced racers?
                                                    </button>
                                                </h5>
                                                <div id="faq2" class="accordion-collapse show" data-bs-parent="#accordion">
                                                    <div class="accordion-body">
                                                        Yes! We offer races and track days tailored for all skill levels. Whether you're a beginner or a seasoned pro, you'll find exciting challenges and opportunities to improve.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item mb-4 wow fadeInUp" data-wow-delay=".7s">
                                                <h5 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3" aria-expanded="false" aria-controls="faq3">
                                                        Do you provide full restorations for vintage motorcycles?
                                                    </button>
                                                </h5>
                                                <div id="faq3" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                                    <div class="accordion-body">
                                                        Yes! We offer races and track days tailored for all skill levels. Whether you're a beginner or a seasoned pro, you'll find exciting challenges and opportunities to improve. 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item wow fadeInUp" data-wow-delay=".8s">
                                                <h5 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq4" aria-expanded="false" aria-controls="faq4">
                                                        Are there exclusive merchandise items for club members?
                                                    </button>
                                                </h5>
                                                <div id="faq4" class="accordion-collapse collapse" data-bs-parent="#accordion">
                                                    <div class="accordion-body">
                                                        Yes! We offer races and track days tailored for all skill levels. Whether you're a beginner or a seasoned pro, you'll find exciting challenges and opportunities to improve.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="gt-main-sideber sticky-style">
                                <div class="gt-single-sideber-widget">
                                    <div class="gt-widget-title">
                                        <h3>All Categories</h3>
                                    </div>
                                    <ul class="gt-category-list">
                                        <li><a href="service-details.html">Property Management</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="service-details.html">Leasing & Rental Services</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="service-details.html">Tenant Screening & Placementr</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="service-details.html">Online Booking & Inquiry</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="service-details.html">Cleaning & Facility Management</a><span><i class="flaticon-right-arrow"></i></span></li>
                                        <li><a href="service-details.html">Interior Design & Fit-Out</a><span><i class="flaticon-right-arrow"></i></span></li>
                                    </ul>
                                </div>
                                
                                <div class="service-details-sidebar bg-cover"   style={{ backgroundImage: "url('/assets/img/inner-page/service-details/contact-bg.jpg')",
  }}
>
                                    <a href="index-2.html">
                                        <img src="assets/img/inner-page/service-details/logo.svg" alt="img"/>
                                    </a>
                                    <div class="gt-content">
                                        <span> Any Questions? Let’s talk</span>
                                        <h3><a href="tel:++0094382229540">+009 (438) 222 9540 </a></h3>
                                        <a href="contact.html" class="theme-btn">
                                           GET A CALL BACK <i class="flaticon-home"></i> 
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
<Footer />
    </div>
  )
}

export default ServiceDetail